import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Event, NavigationExtras, Params, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable()
export class CoreRouteService {

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public localize: LocalizeRouterService,
  ) { }

  events(): Observable<Event> {
    return this.router.events as Observable<Event>;
  }

  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate([...this.localize.translateRoute(commands)], extras);
  }

  navigateWithPropertyPrefix(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate([...this.localize.translateRoute(commands)], extras);
  }

  snapshot(): ActivatedRouteSnapshot {
    return this.route.snapshot;
  }

  params(): Observable<Params> {
    return this.route.params;
  }



}
